export const enum SubscriptionTypesPaymentMethodEnum {
  creditCard = 'credit_card',
  embeddedCreditCard = 'embedded_credit_card',
  bankTransfer = 'bank_transfer',
  zidWallet = 'zid_wallet',
  applePay = 'apple_pay',
  savedCard = 'saved_card',
}
